import { Tabs } from '@isyc-react/animation';
import { useApiCoursesDatesQuery, useApiCoursesEventsQuery, useApiCoursesSizeQuery } from 'common/api/queries';
import { HOME_STALE_TIME_MS } from 'common/api/queries/query.constants';
import { useAuthContext } from 'common/auth/modules/context';
import { namespaces } from 'i18n/i18n.constants';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { CoursesHistoryContainer, CoursesOfferContainer, CurrentCoursesContainer } from './tabs';
import { HomeCalendar } from './homeCalendar.component';
import { ThemeContext } from 'core/router/logged';
import dayjs from 'dayjs';
import { CoursesMoodleContainer } from './tabs/courses-moodle.container';
export const Home = props => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const { user } = useAuthContext();
    const navigate = useNavigate();
    const { t } = useTranslation(namespaces.common);
    const { currentTab, setCurrentTab } = useContext(ThemeContext);
    const { data: dataCoursesSize, isLoading: isLoadingCoursesSize, dataUpdatedAt: coursesSizeUpdatedAt, refetch: refetchCoursesSize, } = useApiCoursesSizeQuery();
    const sizeCurrentCourses = (_b = (_a = dataCoursesSize === null || dataCoursesSize === void 0 ? void 0 : dataCoursesSize.data) === null || _a === void 0 ? void 0 : _a.sizeCurrentCourses) !== null && _b !== void 0 ? _b : 0;
    const sizeCoursesOffer = (_d = (_c = dataCoursesSize === null || dataCoursesSize === void 0 ? void 0 : dataCoursesSize.data) === null || _c === void 0 ? void 0 : _c.sizeCoursesOffer) !== null && _d !== void 0 ? _d : 0;
    const sizeCoursesHistory = (_f = (_e = dataCoursesSize === null || dataCoursesSize === void 0 ? void 0 : dataCoursesSize.data) === null || _e === void 0 ? void 0 : _e.sizeCoursesHistory) !== null && _f !== void 0 ? _f : 0;
    const sizeCoursesMoodle = (_h = (_g = dataCoursesSize === null || dataCoursesSize === void 0 ? void 0 : dataCoursesSize.data) === null || _g === void 0 ? void 0 : _g.sizeCoursesMoodle) !== null && _h !== void 0 ? _h : 0;
    const { data: dataCoursesEvents } = useApiCoursesEventsQuery();
    const coursesEvents = dataCoursesEvents === null || dataCoursesEvents === void 0 ? void 0 : dataCoursesEvents.data;
    const { data: dataCoursesDates } = useApiCoursesDatesQuery();
    const coursesDates = dataCoursesDates === null || dataCoursesDates === void 0 ? void 0 : dataCoursesDates.data;
    React.useEffect(() => {
        const now = Date.now();
        const isStale = now - coursesSizeUpdatedAt > HOME_STALE_TIME_MS;
        if (coursesSizeUpdatedAt > 0 && isStale) {
            refetchCoursesSize();
        }
    }, [coursesSizeUpdatedAt, currentTab, refetchCoursesSize]);
    const tabs = React.useMemo(() => [
        {
            header: (React.createElement(React.Fragment, null,
                t('ls.tabs.offer'),
                " (",
                sizeCoursesOffer,
                ")")),
            content: () => {
                return (React.createElement(React.Fragment, null, !isLoadingCoursesSize && (React.createElement("div", { className: 'info w-100 pb-1' },
                    React.createElement(CoursesOfferContainer, null)))));
            },
        },
        {
            header: (React.createElement(React.Fragment, null,
                t('ls.tabs.courses'),
                " (",
                sizeCurrentCourses,
                ")")),
            content: () => {
                return (React.createElement(React.Fragment, null, !isLoadingCoursesSize && (React.createElement("div", { className: 'info w-100 pb-1' },
                    React.createElement(CurrentCoursesContainer, null)))));
            },
        },
        {
            header: (React.createElement(React.Fragment, null,
                t('ls.tabs.history'),
                " (",
                sizeCoursesHistory,
                ")")),
            content: () => {
                return (React.createElement(React.Fragment, null, !isLoadingCoursesSize && (React.createElement("div", { className: 'info w-100 pb-1' },
                    React.createElement(CoursesHistoryContainer, null)))));
            },
        },
        {
            header: (React.createElement(React.Fragment, null,
                t('ls.tabs.moodle'),
                " (",
                sizeCoursesMoodle,
                ")")),
            content: () => {
                return (React.createElement(React.Fragment, null, !isLoadingCoursesSize && (React.createElement("div", { className: 'info w-100 pb-1' },
                    React.createElement(CoursesMoodleContainer, null)))));
            },
        },
    ], [isLoadingCoursesSize, sizeCoursesHistory, sizeCoursesMoodle, sizeCoursesOffer, sizeCurrentCourses, t]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'container mx-auto p-0 bg-white mb-5' },
            React.createElement("div", { className: 'info shadow-sm' },
                React.createElement("div", { className: 'tabs' },
                    React.createElement(Tabs, { current: currentTab, onChange: current => setCurrentTab(current), className: 'tabs-dashboard', tabs: tabs, initialSlide: false })))),
        React.createElement("div", { className: 'container mx-auto p-0 bg-white' },
            React.createElement("div", { className: 'info shadow-sm' },
                React.createElement("div", { className: 'events' },
                    React.createElement("div", { className: 'row' },
                        React.createElement("div", { className: 'col-md' },
                            React.createElement("h2", { className: 'text-primary mb-5' },
                                React.createElement("span", { className: 'mdi mdi-bookmark-check-outline text-primary me-2' }),
                                t('ls.home.nextEvents')),
                            React.createElement("ul", null, coursesEvents &&
                                (coursesEvents === null || coursesEvents === void 0 ? void 0 : coursesEvents.length) > 0 &&
                                (coursesEvents === null || coursesEvents === void 0 ? void 0 : coursesEvents.map((item, i) => (React.createElement("li", null,
                                    item.curso,
                                    " ",
                                    dayjs(item.fecha_order).format('DD-MM-YYYY'),
                                    ' ',
                                    item.info != '' ? '(' + item.info + ')' : '')))))),
                        React.createElement("div", { className: 'col-md-auto d-flex justify-content-start justify-content-xl-end' },
                            React.createElement(HomeCalendar, { coursesDates: coursesDates }))))))));
};
